import { gql } from "graphql-request";

const peopleModule = window.cornerstonePeopleModuleId;

const consentGiveMutation = gql`
mutation ConsentGive($email: String!, $consentIds: [Int]!) {
  room {
    people(id: ${peopleModule}) {
      consentsGive(
        data: {
          ids: $consentIds, email: $email
        }
      ) {
        userErrors {
          field
          message
        }
      }
    }
  }
}
`;

export {
  consentGiveMutation
};
